import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import DropdownItemApprove from "../../../../ui/components/DropdownMenu/DropdownItemApprove";
import DropdownItemDeny from "../../../../ui/components/DropdownMenu/DropdownItemDeny";
import DropdownItemSoftDelete from "../../../../ui/components/DropdownMenu/DropdownItemSoftDelete";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function PriceDropdownMenu({ price }) {
	const { t } = useTranslation();

	return (
		<DropdownMenu>
			{(context) => (
				<>
					<DropdownItemApprove data={price} {...context} />
					<DropdownItemDeny data={price} {...context} />

					<Dropdown.Item as={Link} to={`/producer/${price.producer.id}/finance/prices/${price.id}`}>
						{t("showMore", "Show more")}
					</Dropdown.Item>

					<DropdownItemSoftDelete data={price} {...context} />
				</>
			)}
		</DropdownMenu>
	);
}
